import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import NukaCarousel from 'nuka-carousel';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { styled } from 'styled-components';
import { v4 as uuid } from 'uuid';
import { Box } from '@design-system/box';
import { useBreakpoint } from '@design-system/theme';
import { Control } from './components/Control';
import { ITEMS_PER_PAGE_DEFAULT } from './constant';
import { shouldLoadMore } from './utils';
import { getArrowTopPositionInSlider } from './utils/getArrowTopPositionInSlider';
const Carousel = NukaCarousel.default
    ?
        NukaCarousel.default
    : NukaCarousel;
export const Slider = ({ ItemComponent, LoadingItemComponent, afterSlide, beforeSlide, cellAlign = 'left', enableKeyboardControls, infinite = false, items = [], keyCodeConfig, loading = false, onLoadMore, perPageBreakpoints = ITEMS_PER_PAGE_DEFAULT, pictureHeight, pictureSpace = 0, renderItemComponent, renderLoadingItemComponent, slideIndex, total, }) => {
    const breakpoint = useBreakpoint();
    const perPage = perPageBreakpoints[breakpoint];
    const currentSlideRef = useRef(slideIndex !== null && slideIndex !== void 0 ? slideIndex : 0);
    const itemsCount = items.length;
    const navTopPosition = useMemo(() => pictureHeight &&
        getArrowTopPositionInSlider({
            pictureHeight,
            pictureSpace,
        }), [pictureHeight, pictureSpace]);
    const loadingItemsCount = Math.min(total && total > 0 ? total - items.length : perPage, perPage);
    const controlProps = {
        breakpoint,
        infinite,
        itemsCount,
        loading,
        navTopPosition,
        perPage,
        total,
    };
    const loadMoreObserver = useCallback((currentSlide) => {
        currentSlideRef.current = currentSlide;
        if (onLoadMore &&
            shouldLoadMore({
                currentSlide,
                itemsCount,
                loading,
                perPage,
                total,
            })) {
            onLoadMore();
        }
    }, [itemsCount, loading, onLoadMore, perPage, total]);
    const handleAfterSlide = (currentSlide) => {
        loadMoreObserver(currentSlide);
        afterSlide === null || afterSlide === void 0 ? void 0 : afterSlide(currentSlide);
    };
    useEffect(() => {
        loadMoreObserver(currentSlideRef.current);
    }, [itemsCount, loadMoreObserver]);
    return (_jsxs(StyledCarousel, { afterSlide: handleAfterSlide, beforeSlide: beforeSlide, carouselId: uuid(), cellAlign: cellAlign, cellSpacing: 24, disableEdgeSwiping: true, enableKeyboardControls: enableKeyboardControls, keyCodeConfig: keyCodeConfig, renderBottomCenterControls: null, renderCenterLeftControls: (props) => (_jsx(Control, Object.assign({}, controlProps, props, { isPrev: true }))), renderCenterRightControls: (props) => (_jsx(Control, Object.assign({}, controlProps, props))), slideIndex: slideIndex, slidesToScroll: perPage, slidesToShow: perPage, withoutControls: Boolean(items) && (total !== null && total !== void 0 ? total : itemsCount) <= perPage && !infinite, wrapAround: infinite, children: [items === null || items === void 0 ? void 0 : items.map((item, index) => {
                var _a;
                return (_jsx(StyledBox, { children: ItemComponent ? (_jsx(ItemComponent, Object.assign({}, item, { index: index }), item.id)) : (renderItemComponent(Object.assign(Object.assign({}, item), { index }))) }, (_a = item.id) !== null && _a !== void 0 ? _a : index));
            }), loading &&
                Array.from({
                    length: loadingItemsCount,
                }).map((_, index) => (_jsx(StyledBox, { children: LoadingItemComponent ? (_jsx(LoadingItemComponent, { index: itemsCount + index })) : (renderLoadingItemComponent({ index: itemsCount + index })) }, itemsCount + index)))] }));
};
const StyledBox = styled(Box).attrs(() => ({
    display: 'block',
    height: '100%',
    width: '100%',
})) ``;
const StyledCarousel = styled(Carousel) `
  margin-left: -12px;
  margin-right: -12px;
  padding-bottom: 6px;
  padding-top: 6px;
  width: auto !important;
`;
//# sourceMappingURL=Slider.js.map